import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '@/api/users';
import { format } from 'date-fns';
import clsx from 'clsx';

const ACTION_COLOR: Record<string, string> = {
  BAN: 'text-red-400',
  GLOBAL_BAN: 'text-red-500 font-bold',
  KICK: 'text-orange-400',
  MUTE: 'text-yellow-400',
  UNBAN: 'text-green-400',
  GLOBAL_UNBAN: 'text-green-400',
  UNMUTE: 'text-green-300',
  WARN: 'text-blue-400',
};

export default function AdminModlog() {
  const [cursor, setCursor] = useState<string | undefined>();

  const { data, isLoading } = useQuery({
    queryKey: ['admin-modlog', cursor],
    queryFn: () => adminApi.getModerationLog({ cursor, limit: 50 }),
  });

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-surface-50 mb-6">Moderation Log</h1>

      {isLoading ? (
        <div className="text-surface-500">Loading…</div>
      ) : (
        <div className="bg-surface-900 border border-surface-800 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-surface-800">
                <th className="text-left px-4 py-3 text-surface-400 font-medium">When</th>
                <th className="text-left px-4 py-3 text-surface-400 font-medium">Action</th>
                <th className="text-left px-4 py-3 text-surface-400 font-medium">Target</th>
                <th className="text-left px-4 py-3 text-surface-400 font-medium">By</th>
                <th className="text-left px-4 py-3 text-surface-400 font-medium">Reason</th>
              </tr>
            </thead>
            <tbody>
              {data?.data.map((log) => (
                <tr key={log.id} className="border-b border-surface-800/50 hover:bg-surface-800/30">
                  <td className="px-4 py-2.5 text-surface-500 text-xs whitespace-nowrap">
                    {format(new Date(log.createdAt), 'MMM d, HH:mm')}
                  </td>
                  <td className={clsx('px-4 py-2.5 font-mono text-xs', ACTION_COLOR[log.action] ?? 'text-surface-300')}>
                    {log.action}
                  </td>
                  <td className="px-4 py-2.5 text-surface-300 text-xs font-mono">
                    @{log.target.username}
                  </td>
                  <td className="px-4 py-2.5 text-surface-400 text-xs font-mono">
                    @{log.moderator.username}
                  </td>
                  <td className="px-4 py-2.5 text-surface-500 text-xs truncate max-w-[200px]">
                    {log.reason ?? '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {data?.nextCursor && (
        <button
          onClick={() => setCursor(data.nextCursor ?? undefined)}
          className="btn-ghost text-xs mt-4"
        >
          Load more
        </button>
      )}
    </div>
  );
}
